module.exports = __webpack_public_path__ + "static/img/weixin_coder.e643fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin_coder.png
// module id = I67x
// module chunks = 5